import React from 'react';

import styles from './column-close-section.module.scss';

interface Props {
	columnName: string;
	openSection: () => void;
}

const ColumnCloseSection = ({ columnName, openSection }: Props) => {
	return (
		<div
			className={styles.sectionContainer}
			onClick={openSection}
			data-test-id={`column-close-section-container-${columnName}`}
			title={columnName}
		>
			<div className={styles.dummyHeader} />
			<div className={styles.sectionTextContainer}>
				<div className={styles.sectionText}>
					<span>{columnName}</span>
				</div>
			</div>
		</div>
	);
};

export default ColumnCloseSection;
